import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import {
  IInjectedDrawerProps,
  INotificationDto,
  INotificationEditDrawerProps,
} from "@ryde/shared";

import { DrawerFormProviderWrapper } from "../edit-form";
import { NotificationEditContent } from "./crud";

export const NotificationEditFormDrawer: FC<
  INotificationEditDrawerProps & IInjectedDrawerProps
> = ({ resolveFn, onCloseDrawer, mode, id, drawerNumber }) => {
  return (
    <CrudEditContextWrapper<INotificationDto>
      entity="notification"
      mode={mode}
      id={id}
    >
      <DrawerFormProviderWrapper>
        <NotificationEditContent
          resolveFn={resolveFn}
          onCloseDrawer={onCloseDrawer}
          drawerNumber={drawerNumber}
        />
      </DrawerFormProviderWrapper>
    </CrudEditContextWrapper>
  );
};
